<template>
	<header>
		<nav class="navbar navbar-expand-lg mb-3" :class="{
			'bg-warning navbar-dark': isDevelopmentEnvironment,
			'bg-primary navbar-light': isProductionEnvironment,
		}">
			<div class="container">
				<router-link to="/" class="navbar-brand">
					{{ $t('header.brand') }}
				</router-link>
				<ul class="navbar-nav ms-auto align-items-center">
					<li class="nav-item ms-2">
						<div class="lang-toggle">
							<img
								class="lang-btn"
								:class="{ active: $lang.locale === 'it' }"
								src="img/flags/it.png"
								@click="$setLang('it')"
								title="Italiano">
							<img
								class="lang-btn"
								:class="{ active: $lang.locale === 'en' }"
								src="img/flags/en.png"
								@click="$setLang('en')"
								title="English">
						</div>
					</li>
				</ul>

				<ul class="navbar-nav ms-auto align-items-center">
					<li class="nav-item" v-if="isDevelopmentEnvironment">
						<a href="#" class="nav-link text-white">
							{{ $t('header.development') }}
						</a>
					</li>
					<li class="nav-item" v-if="isOffline">
						<a href="#" class="nav-link text-yellow">
							&#9888;
							{{ $t('header.offline') }}
						</a>
					</li>
				</ul>
			</div>
		</nav>
	</header>
</template>

<script>

export default {
	name: 'MainHeader',

	data() {
		return {
			isOnline: navigator.onLine
		}
	},

	mounted() {
		window.addEventListener("online", () => this.isOnline = true)
		window.addEventListener("offline", () => this.isOnline = false)
	},

	computed: {
		isOffline() {
			return !this.isOnline;
		},

		isProductionEnvironment() {
			return location.hostname === "app.timbratore.zato.servonet.it";
		},

		isDevelopmentEnvironment() {
			return !this.isProductionEnvironment;
		}
	}

}
</script>

<style scoped>
.lang-toggle {
	display: flex;
	gap: 4px;
}

.lang-btn {
	background: none;
	border: 2px solid transparent;
	border-radius: 4px;
	cursor: pointer;
	font-size: 1.3rem;
	line-height: 1;
	padding: 2px 4px;
	opacity: 0.45;
	transition: opacity 0.15s, border-color 0.15s;
}

.lang-btn:hover {
	opacity: 0.75;
}

.lang-btn.active {
	opacity: 1;
	border-color: rgba(255, 255, 255, 0.6);
}
</style>